import React, { Component } from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { Button, Row, Col, Card } from 'react-bootstrap';

import {
  isSharedUser,
  getId,
  getPublicUserId,
  isWithLocationUser
} from '../../../api/Maps/map-operations';

import ColBreak from '../../atoms/ColBreak';
import ShareIcon from '../../atoms/ShareIcon';

class MapShareUserPublicComponent extends Component {
  state = { isCopied: false };

  render() {
    const { map, toggleSharedUser, toggleWithLocationUser, location, isPublicMap } = this.props;
    const { isCopied } = this.state;
    const stringMap = isWithLocationUser(map)
      ? `/lng=${location.lng}&lat=${location.lat}&zoom=${location.zoom}`
      : '';
    const nameLocation = isWithLocationUser(map) ? 'with location' : '';
    const textToCopy = `<div style="border: 2px solid rgb(201, 0, 1); height: 60vh; width: 98vw; overflow: hidden;"><iframe src="${Meteor.absoluteUrl(
      `sharedUser/maps/${getPublicUserId(map)}/${stringMap}`
    )}" height="125%" width="100%" style="border: 0px none; margin-top: -17%;" >This browser does not support this element</iframe></div><p><a href="${Meteor.absoluteUrl(
      `sharedUser/maps/${getPublicUserId(map)}/${stringMap}`
    )}" target="_blank">View in Ipsilum Web</a></p>`;

    return (
      <Row>
        {!isPublicMap && (
          <>
            <Col xs={6} sm={8} md={10}>
              <Button
                block
                onClick={() => {
                  toggleSharedUser(getId(map), isSharedUser(map));
                }}
                variant={isSharedUser(map) ? 'outline-success' : 'outline-info'}
                style={
                  isSharedUser(map)
                    ? { color: '', borderColor: '' }
                    : { color: '#2A3F90', borderColor: '#2A3F90' }
                }
              >
                {isSharedUser(map)
                  ? 'Cerrar compartir mapa público con usuarios'
                  : 'Compartir mapa público con usuarios'}
              </Button>
            </Col>
            <Col xs={6} sm={4} md={2} className="d-flex justify-content-center">
              <ShareIcon shared={isSharedUser(map)} />
            </Col>
            <ColBreak />
            <Col xs={6} sm={8} md={10}>
              <Button
                block
                onClick={() => {
                  toggleSharedUser(getId(map), isSharedUser(map));
                  toggleWithLocationUser(getId(map), isWithLocationUser(map));
                }}
                variant={isSharedUser(map) ? 'outline-success' : 'outline-info'}
                style={
                  isSharedUser(map)
                    ? { color: '', borderColor: '' }
                    : { color: '#2A3F90', borderColor: '#2A3F90' }
                }
              >
                {isSharedUser(map)
                  ? 'Cerrar compartir mapa público con usuarios con localización'
                  : 'Compartir mapa público con usuarios con localización'}
              </Button>
            </Col>
          </>
        )}
        {(isSharedUser(map) || isPublicMap) && (
          <>
            <ColBreak />
            <Col xs={12}>
              <Card bg="light">
                <Card.Body>
                  <Card.Subtitle className="mb-2 text-muted">
                    Shared Link {nameLocation}
                  </Card.Subtitle>
                  <Card.Link
                    href={`${Meteor.absoluteUrl(
                      `sharedUser/maps/${getPublicUserId(map)}${stringMap}`
                    )}`}
                    target="_blank"
                    className="text-break"
                    rel="noopener noreferrer"
                  >
                    {`${Meteor.absoluteUrl(`sharedUser/maps/${getPublicUserId(map)}${stringMap}`)}`}
                  </Card.Link>
                </Card.Body>
              </Card>
              <Card bg="light">
                <Card.Header>
                  iframe Code
                  <Button
                    className="float-right"
                    onClick={() => {
                      copy(textToCopy);
                      this.setState({ isCopied: true });
                    }}
                    size="sm"
                    variant="outline"
                  >
                    {isCopied ? 'Copiado' : 'Copiar'}
                  </Button>
                </Card.Header>
                <Card.Body>
                  <pre className="pre-scrollable text-truncate overflow-hidden">
                    <code className="language-html" data-lang="html">
                      &lt;div style=&quot;border: 2px solid rgb(201, 0, 1); height: 60vh; width:
                      95vw; overflow: hidden; position: relative; display: flex; flex-flow: row
                      wrap; align-items: stretch; align-content: stretch;&quot;&gt;&lt;iframe
                      src=&quot;
                      {Meteor.absoluteUrl(`sharedUser/map/${getPublicUserId(map)}`)}
                      &quot; scrolling=&quot;no&quot; style=&quot;border: 0px none; flex: 1 100%;
                      margin-top: -109px; margin-bottom: -65px;&quot; &gt; This browser does not
                      support this element &lt;/iframe&gt; &lt;/div&gt; &lt;p&gt;&lt;a href=&quot;
                      {Meteor.absoluteUrl(`sharedUser/map/${getPublicUserId(map)}`)}
                      &quot; target=&quot;_blank&quot;&gt;View in Ipsilum Web&lt;/a&gt;&lt;/p&gt;
                    </code>
                  </pre>
                </Card.Body>
              </Card>
            </Col>
          </>
        )}
      </Row>
    );
  }
}

MapShareUserPublicComponent.defaultProps = {
  isPublicMap: false,
  location: {}
};
MapShareUserPublicComponent.propTypes = {
  isPublicMap: PropTypes.bool,
  location: PropTypes.object,
  map: PropTypes.object.isRequired,
  toggleSharedUser: PropTypes.func.isRequired,
  toggleWithLocationUser: PropTypes.func.isRequired
};

export default MapShareUserPublicComponent;
